<div class="d-flex" [ngClass]="theme ? '': 'dark' ">
  <div class="container-fluid p-0" [ngClass]="theme ? '': 'banner' ">
    <div class="row m-0 p-4">
      <div class="col-sm-12 p-0">
        <div class="d-flex align-items-center justify-content-between">
          <!-- <i class="bi bi-arrow-left-short fs-3" role="button" routerLink="/content-editor/text-editor"></i> -->
          <h1 class="fw-bold m-0 heading">Explore Competitors Outline</h1>
          <i
              class="bi bi-x-lg fw-bold" (click)="closeModal()" role="button"></i>
          <!-- <button type="button" class="btn-close"  (click)="closeModal()"><i
              class="bi bi-x-lg fw-bold text-white"></i></button> -->
        </div>
      </div>
      <div class="p-0 pe-20 border-right col-8">


        <nav class="nav border-bottom my-4" [ngClass]="theme ? 'light-nav-link': 'dark-nav-link' ">
          <a class="nav-link dark-link" [ngClass]="{'active': activateLink == 'Competitors Outline'}" role="button"
            (click)="activateLink = 'Competitors Outline'">Competitors Outline</a>
          <!-- <a class="nav-link dark-link" role="button" [ngClass]="{'active': activateLink == 'Questions'}"
            (click)="activateLink = 'Questions'">Questions</a> -->
        </nav>
        <div *ngIf="activateLink === 'Competitors Outline'">
          <div class="d-flex">
            <h4 class="m-0 no-wrap mt-2 heading">SERP Position</h4>
            <div class="ms-3">
              <div class="d-flex">
                <button class="btn btn-light d-flex fs-16 fw-600 me-2 my-1" (click)="SRTPPosition = i+1;getSerpData(i)"
                  *ngFor="let data of outline.slice(0,10),index as i" style="width: 45px;"
                  [ngClass]="{'active-btn' : SRTPPosition == i+1}">{{i + 1 |
                  number : '2.0' }}</button>
              </div>
              <div class="d-flex">
                <button class="btn btn-light d-flex fs-16 fw-600 me-2 my-1" style="width: 45px;"
                  (click)="SRTPPosition = 11+i;getSerpData(10+i)"
                  *ngFor="let data of outline.slice(10,outline?.length),index as i"
                  [ngClass]="{'active-btn' : SRTPPosition == 11+i}">{{11 + i }}</button>
              </div>

            </div>
          </div>
          <div class="border rounded-4 p-3 mt-4 left-content">
            <div class="mb-3">
              <div class="d-flex align-items-center">
                <img [src]="compititorsData.image" class="rounded-3" alt="" height="24" width="24">
                <h3 class="m-0 ms-2 fw-bold heading">{{compititorsData.title}}</h3>
              </div>
              <a [href]="compititorsData?.link" target="_blank"
                class="text-decoration-none">{{compititorsData?.link}}</a>
              <h3 class="dull-white mb-1">{{compititorsData?.description}}</h3>
            </div>
            <div class="mt-1" *ngFor="let data of newCompititorsOutline">

              <!-- <mat-accordion class="box-shadow-none ps-4">
                <mat-expansion-panel hideToggle (opened)="data.panelOpenState = true"
                  (closed)="data.panelOpenState = false" class="px-4 py-2 {{className}}">
                  <mat-expansion-panel-header>
                    <mat-panel-title class="d-flex align-items-center justify-content-between border-bottom pb-2">
                      <div class="d-flex align-items-center">
                        <div *ngIf="data.arr.length > 0">
                          <mat-icon *ngIf="!data.panelOpenState" class="arrow-icon">keyboard_arrow_down</mat-icon>
                          <mat-icon *ngIf="data.panelOpenState" class="arrow-icon">keyboard_arrow_up</mat-icon>
                        </div>
                        <h3 class="m-0 fw-bold mx-2 text-green">{{data.tag_name}}</h3>
                        <h3 class="m-0 fw-bold">{{data.tag_value}}</h3>
                      </div>
                      <div class="d-flex align-items-center">
                        <button class="btn btn-light d-flex fs-16 fw-600 me-2 my-1 b-36 align-items-center" (click)="addAll(data)">
                          <i class="bi bi-plus me-2"></i> All
                        </button>
                        <button class="btn btn-light d-flex fs-16 fw-600 me-2 my-1 b-36 align-items-center" (click)="add(data)">
                          <i class="bi bi-plus me-2"></i> {{data.tag_name}}
                        </button>
                        <button class="btn btn-light d-flex fs-16 fw-600 me-2 my-1 b-36 align-items-center">
                          <mat-icon>visibility</mat-icon>
                        </button>
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div *ngFor="let tag of data?.arr">
                    <div class="d-flex align-items-center justify-content-between pt-2">
                      <div class="d-flex align-items-center">
                        <h3 class="m-0 fw-600 ms-4 ps-2 text-green">{{tag.tag_name}}</h3>
                        <h3 class="m-0 fw-600 ps-2 light-content">{{tag.tag_value}}</h3>
                      </div>
                      <div class="d-flex align-items-center">
                        <button class="btn btn-light rounded-pill d-flex align-items-center" (click)="add(tag)">
                          <mat-icon class="me-2">add</mat-icon>{{tag.tag_name}}
                        </button>
                        <button class="btn btn-light rounded-circle d-flex align-items-center">
                          <mat-icon *ngIf="tag.isVisible" (click)="tag.isVisible=false">visibility</mat-icon>
                          <mat-icon *ngIf="!tag.isVisible" (click)="tag.isVisible=true">visibility_off</mat-icon>
                        </button>
                      </div>
                    </div>
                  </div>

                </mat-expansion-panel>
              </mat-accordion> -->

              <div class="comp d-flex align-items-center justify-content-between border-bottom pb-2 mb-2">
                <div class="d-flex">
                  <h4 class="me-2 text-green fw-bold mb-0 fs-14">{{data.tag_name}}</h4>
                  <h4 class="fw-bold mb-0 fs-14 light-neutral dark-black heading">{{data.tag_value}}</h4>
                </div>
                <div class="d-flex align-items-center">
                  <button class="btn btn-light d-flex fs-16 fw-600 me-2  b-36 align-items-center mb-0"
                    *ngIf="data?.arr?.length>0" (click)="addAll(data)" style="height: 30px;">
                    <i class="bi bi-plus me-2"></i> All
                  </button>
                  <button class="btn btn-light d-flex fs-16 fw-600 me-2  b-36 align-items-center mb-0 text-uppercase"
                    (click)="add(data)" style="height: 30px;">
                    <i class="bi bi-plus me-2"></i> {{data.tag_name}}
                  </button>
                  <!-- <button class="btn btn-light d-flex fs-16 fw-600 me-2  b-36 align-items-center mb-0 "
                    style="height: 30px;">
                    <mat-icon class="eye-icon">visibility</mat-icon>
                  </button> -->
                </div>
              </div>

              <div class="ps-4">
                <div *ngFor="let tag of data?.arr">
                  <div class="d-flex align-items-center justify-content-between mb-2">
                    <div class="d-flex">
                      <h3 class="m-0 fw-500 text-green fw-bold me-2 fs-14">{{tag.tag_name}}</h3>
                      <h3 class="m-0 fw-500 light-neutral dark-black fw-bold fs-14 heading">{{tag.tag_value}}</h3>
                    </div>
                    <div class="d-flex align-items-center">
                      <button
                        class="btn btn-light d-flex fs-16 fw-600 me-2  b-36 align-items-center mb-0 text-uppercase"
                        (click)="add(tag)" style="height: 30px;">
                        <i class="bi bi-plus me-2"></i>{{tag.tag_name}}
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div *ngIf="activateLink === 'Questions'">
          <div class="d-flex">
            <h4 class="m-0 no-wrap mt-2">Source</h4>
            <div class="d-flex flex-wrap ms-3">
              <button class="btn btn-light d-flex fs-16 fw-600 me-2 my-1" (click)="source = i+1"
                *ngFor="let data of sourceData,index as i" [ngClass]="{'active-btn' : source == i+1}">{{data}}</button>
            </div>
          </div>
          <table class="table hover mt-4" [ngClass]="theme ? '': 'dark-table' ">
            <thead>
              <tr class="table-content">
                <th scope="col" class="text-gray fw-normal">
                  <input class="form-check-input" type="checkbox" [(ngModel)]="masterSelected" (change)="checkAll()"
                    role="button">
                </th>
                <th scope="col" class="text-gray fw-bold">Topic and Question</th>
                <th scope="col" class="text-gray fw-bold">Add Tag</th>
              </tr>
            </thead>
            <tbody class="align-middle table-body">
              <tr *ngFor="let data of tableData;index as i" [ngClass]="{'bg-light-blue' : data.isChecked}">
                <td>
                  <input class="form-check-input checkbox" (change)="isAllSelected()" [(ngModel)]="data.isChecked"
                    type="checkbox" role="button">
                </td>
                <td>She was the type of girl who wanted to live in a pink house?</td>
                <td>
                  <div class="d-flex">
                    <button class="btn btn-light rounded-pill d-flex align-items-center me-2">
                      <mat-icon class="me-2">add</mat-icon> H2
                    </button>
                    <button class="btn btn-light rounded-pill d-flex align-items-center">
                      <mat-icon class="me-2">add</mat-icon> H3
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="p-0 ps-20 col-4">
        <div class="d-flex align-items-center justify-content-between my-3 flex-wrap border-bottom pb-3">
          <h2 class="fw-bold m-0 heading">Outline</h2>
          <button class="btn d-flex align-items-center rounded-pill fs-14 fw-600 me-1 btn-primary" (click)="saveData()" [disabled]="!uid">
            <mat-icon class="copy-icon d-flex align-items-center justify-content-center fs-16">save</mat-icon>
            Save
          </button>
        </div>
        <!-- <div class="d-flex align-items-center flex-wrap pb-3 border-bottom">
          <div class="btn btn-light d-flex fs-16 fw-600 me-2 my-1 b-36 align-items-center" role="button"
            (click)="addH2Tage = !addH2Tage" style="height: 36px;">
            <i class="bi bi-plus me-2" *ngIf="!addH2Tage"></i>
            <i class="bi bi-dash me-2" *ngIf="addH2Tage"></i>
            <span class="fs-14 me-2 Neutral dark-content">{{addH2Tage ? 'Remove' : 'Add'}} H2 tag</span>
          </div>
          <div class="d-flex align-items-center mb-1" *ngIf="addH2Tage">
            <input type="text" class="input w-100" placeholder="Enter H2 tag ..." [(ngModel)]="h2Tag">
            <button class="btn btn-primary ms-2 p-2 rounded-circle" [disabled]="h2Tag===''" (click)="addTag('h2')"><i
                class="bi bi-arrow-right-short"></i></button>
          </div>
          <div class="btn btn-light d-flex fs-16 fw-600 me-2 my-1 b-36 align-items-center" role="button"
            (click)="addH3Tage = !addH3Tage" style="height: 36px;">
            <i class="bi bi-plus me-2" *ngIf="!addH3Tage"></i>
            <i class="bi bi-dash me-2" *ngIf="addH3Tage"></i>
            <span class="fs-14 me-2 Neutral dark-content">{{addH3Tage ? 'Remove' : 'Add'}} H3 tag</span>
          </div>
          <div class="d-flex align-items-center mb-1" *ngIf="addH3Tage">
            <input type="text" class="input w-100" placeholder="Enter H3 tag ..." [(ngModel)]="h3Tag">
            <button class="btn btn-primary ms-2 p-2 rounded-circle" [disabled]="h3Tag===''" (click)="addTag('h3')"><i
                class="bi bi-arrow-right-short"></i></button>
          </div>
        </div> -->
        <div class="p-2 flex-wrap border rounded rounded-4 dark-border mb-2">
          <div class="d-flex align-items-center justify-content-evenly">
            <div class="col-2 text-center NeutralLight fw-600 dull-neutral" role="button" (click)="addH2()" [ngClass]="!uid ? 'disabled-btn' : ''">
              <p class="m-0 me-1" id="h2Tag">+ H2</p>
            </div>
            <div class="col-2 text-center  NeutralLight fw-600 dull-neutral" role="button" (click)="addH3()" [ngClass]="!uid ? 'disabled-btn' : ''">
              <p class="m-0 me-1" id="h3Tag">+ H3</p>
            </div>
          </div>
        </div>
        <div class="outline-wrapper">
          <div class="pb-2 dark-heading-outline" *ngFor="let data of baseOutlineData;let i=index" id="div{{i}}"
            (drop)="drop($event,i)" (dragover)="allowDrop($event,i)" (dragleave)="removeDrag($event,i)">
            <div class="d-flex">
              <div class="w-10" *ngIf="data.tag_name==='h3'" id="divv{{i}}" (drop)="dropTransfer($event,i)"></div>
              <div class="d-flex justify-content-between flex-wrap pb-1 w-100 " id="drag{{i}}" draggable="true"
                (dragstart)="drag($event,i)">
                <div class="d-flex justify-content-between mt-1 w-100 p-2 rounded outline outline-tags"
                [ngClass]="data.tag_name==='h3' ? 'btn-orange':'btn-light-pink'"
                  id="parentEditt{{i}}">
                  <div class="d-flex align-items-center">
                    <mat-icon class="drag-icon" matTooltip="Drag to move">drag_indicator</mat-icon>
                    <!-- <i class="bi bi-grip-vertical text-center text-dark me-2" style="opacity: 0.7;cursor: grab;"></i> -->
                    <h5 class="me-2 text-green fw-bold mb-0 text-capitalize" id="editTag{{i}}">{{data.tag_name}}</h5>
                    <h5 class="fw-bold mb-0 heading" id="editDivv{{i}}" (focusout)="saveTag(i)">
                      {{data.tag_value}}</h5>
                  </div>
                  <div class="d-flex align-items-center">
                    <i class="bi bi-three-dots-vertical action-icons" role="button"
                      [matMenuTriggerFor]="keywordOption" *ngIf="!!data.isEditable"></i>
                    <i class="bi bi-check-lg me-2 draggable" id="check{{i}}" *ngIf="!!data.isCheck" role="button" (click)="saveTag(i)"></i>
                       <!--  <i class="bi bi-pen me-2 draggable" role="button"  id="edit{{i}}" *ngIf="!!data.isEditable" (click)="renameTag(i)"></i>
                          <i class="bi bi-trash3 me-2 draggable" role="button"
                              (click)="deleteTag(i)"></i> -->
                    <mat-menu #keywordOption="matMenu" cxPosition="before" class="{{menu}}">
                      <ng-template matMenuContent let-myobject="myobject">
                        <button mat-menu-item class="w-100 d-flex align-items-center action-btn p-0" *ngIf="data?.tag_name==='h3'" (click)="renameTagName(i,'h2')">
                          <i class="bi bi-type-h2 me-2 fs-16"></i>
                          Change to H2</button>
                        <button mat-menu-item class="w-100 d-flex align-items-center action-btn p-0" *ngIf="data?.tag_name==='h2'" (click)="renameTagName(i,'h3')">
                          <i class="bi bi-type-h3 me-2 fs-16"></i>
                          Change to H3</button>
                        <button mat-menu-item class="w-100 d-flex align-items-center action-btn p-0" id="edit{{i}}"
                          *ngIf="!!data.isEditable" (click)="renameTag(i)">
                          <i class="bi bi-pen me-2 fs-12"></i> Edit</button>
                        <button mat-menu-item class="w-100 d-flex align-items-center action-btn p-0" (click)="deleteTag(i)">
                          <i class="bi bi-trash3 me-2 fs-16" role="button"></i>Delete </button>
                        <!-- <button mat-menu-item class="w-100 d-flex align-items-center action-btn">
                          <i class="bi bi-clipboard2"></i>Copy</button> -->
                      </ng-template>

                    </mat-menu>
                  </div>
                </div>
              </div>
              <div class="w-10" *ngIf="data.tag_name==='h2'" id="divv1{{i}}" (drop)="dropTransfer1($event,i)"></div>
            </div>
            <!-- <div class="ps-4" *ngFor="let subData of data?.arr">
      <div class="d-flex  mt-2 w-100 px-1 py-1 rounded btn-orange">
        <h4 class="me-2 text-green mb-0">{{subData.tag_name}}</h4>
        <h4 class="mb-0">{{subData.tag_value}}</h4>
      </div>
    </div> -->
          </div>
        </div>

      </div>
    </div>
  </div>
</div>